
export const USER_ROLE = {
  ANON: 'Anonymous',
  ADMIN: 'Admin',
  SELLER: 'Seller',
  BUYER: 'Buyer',
} as const;
export type USER_ROLE = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export class User {
  name: string;
  email: string;
  role: USER_ROLE;

  constructor(name: string, email: string, role: USER_ROLE) {
    this.name = name;
    this.email = email;
    this.role = role;
  }

  isAnonymous = () => this.role === USER_ROLE.ANON;
  isBuyer = () => this.role === USER_ROLE.BUYER;
  isSeller = () => this.role === USER_ROLE.SELLER;
  isAdmin = () => this.role === USER_ROLE.ADMIN;
}
